export default function NotificationBellIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M7 10.7c0-3.2 2-5.7 5-5.7s5 2.5 5 5.7v2.9l1.7 2.8H5.3L7 13.6z" />
      <path d="M10 18.5c.4.8 1.1 1.3 2 1.3s1.6-.5 2-1.3" />
      <path d="M12 3.8v-1" />
    </svg>
  )
}
